import {
    FEE_GRANT_ALLOWANCE_ERROR,
    FEE_GRANT_ALLOWANCE_IN_PROGRESS,
    FEE_GRANT_ALLOWANCE_SUCCESS,
    IBC_BALANCE_LIST_FETCH_ERROR,
    IBC_BALANCE_LIST_FETCH_IN_PROGRESS,
    IBC_BALANCE_LIST_FETCH_SUCCESS,
} from '../constants/faucet';
import Axios from 'axios';
import { urlFetchIBCBalance } from '../constants/restURL';
import { FEE_GRANT_ALLOWANCE_URL } from '../constants/url';
import { handleErrorMessage } from '../utils/errorMessages';

const fetchIBCBalanceListInProgress = () => {
    return {
        type: IBC_BALANCE_LIST_FETCH_IN_PROGRESS,
    };
};

const fetchIBCBalanceListSuccess = (value) => {
    return {
        type: IBC_BALANCE_LIST_FETCH_SUCCESS,
        value,
    };
};

const fetchIBCBalanceListError = (message) => {
    return {
        type: IBC_BALANCE_LIST_FETCH_ERROR,
        message,
    };
};

export const fetchIBCBalanceList = (ibcUrl, address) => (dispatch) => {
    dispatch(fetchIBCBalanceListInProgress());

    const url = urlFetchIBCBalance(ibcUrl, address);
    Axios.get(url, {
        headers: {
            Accept: 'application/json, text/plain, */*',
        },
    })
        .then((res) => {
            dispatch(fetchIBCBalanceListSuccess(res.data && res.data.balances));
        })
        .catch((error) => {
            const message = handleErrorMessage(error);
            dispatch(fetchIBCBalanceListError(message));
        });
};

const feeGrantAllowanceInProgress = () => {
    return {
        type: FEE_GRANT_ALLOWANCE_IN_PROGRESS,
    };
};

const feeGrantAllowanceSuccess = (value, message) => {
    return {
        type: FEE_GRANT_ALLOWANCE_SUCCESS,
        value,
        message,
        variant: 'success',
    };
};

const feeGrantAllowanceError = (message) => {
    return {
        type: FEE_GRANT_ALLOWANCE_ERROR,
        message,
        variant: 'error',
    };
};

export const feeGrantAllowanceClaim = (cb) => (dispatch) => {
    dispatch(feeGrantAllowanceInProgress());

    Axios.get(FEE_GRANT_ALLOWANCE_URL, {
        headers: {
            Accept: 'application/json, text/plain, */*',
            Authorization: 'Bearer ' + localStorage.getItem('acToken_of_studio'),
        },
    })
        .then((res) => {
            dispatch(feeGrantAllowanceSuccess(res.data, 'Success'));
            cb(res.data);
        })
        .catch((error) => {
            const message = handleErrorMessage(error);
            dispatch(feeGrantAllowanceError(message));
            cb(null);
        });
};
